import { Participant, PopulatedMatch } from "./bracket.types";

export type TournamentType = "single-elimination" | "double-elimination" | "round-robin";
export enum TournamentTypeEnum {
  SINGLE_ELIMINATION = "single-elimination",
  DOUBLE_ELIMINATION = "double-elimination",
  ROUND_ROBIN = "round-robin",
}
export type TournamentLocation = "online" | "physical";

export enum TournamentLocationEnum {
  ONLINE = "online",
  PHYSICAL = "physical",
}

export type PlatformType = "mobile" | "console";

export enum TournamentStatus {
  UPCOMING = "upcoming",
  LIVE = "live",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  DELETED = "deleted",
}

export type CreateTournamentInput = {
  tournamentName: string;
  description: string;
  tournamentImage: string;
  gameImageUrl: string; 
  selectedGame: string;
  tournamentType: TournamentType;
  fee: number;
  prize: number;
  location: TournamentLocation;
  platform?: PlatformType;
  physicalLocationAddress?: string;
  tournamentDate: string;
  country: string;
  limit?: number | string;
}

export type Round = {
  [matchId: string]: PopulatedMatch;
};

export interface Bracket {
  bracketType: "single-elimination" | "double-elimination" | string;
  rounds?: {
    [roundKey: string]: Round;
  };
  winners?: {
    [roundKey: string]: Round;
  };
  losers?: {
    [roundKey: string]: Round;
  };
  grandFinal?: {
    final?: Round;
  };
  tournamentWinner?: Participant;
  winnersBracketWinner?: Participant;
  losersBracketWinner?: Participant;
  doubleEliminationState?: {
    lastProgressedLosersRound?: string;
  };
}

export type Host = {
  _id: string;
  username: string;
  email: string;
};

export interface Tournament {
  _id: string;
  host: Host;

  tournamentName: string;
  tournamentURL: string;
  description: string;
  tournamentImage: string;

  gameImageUrl: string;
  selectedGame: string;

  tournamentType: TournamentType;
  platform: PlatformType;

  bracketType?: TournamentType;
  bracket: Bracket | null;

  winnersBracket: null;
  losersBracket: null;
  winnersBracketFinal: null;
  losersBracketFinal: null;
  finalMatch: null;

  participants: string[];
  fee: number | string;
  prize: number | string;
  convertedFee: number | string;
  convertedPrize: number | string;
  convertedDate: string;
  convertedDateReadable: string;
  location: TournamentLocation;
  physicalLocationAddress?: string;
  tournamentDate: string;
  displayCurrency: string;
  type?: string;
  country: string;
  limit?: number | null;
  status?: TournamentStatus;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTournamentResponse {
  message: string;
  tournament: Tournament;
}

export interface DeleteTournamentResponse {
  message: string;
}

export interface PaginatedTournamentsResponse {
  message: string;
  tournaments: Tournament[];
  total: number;
  page: number;
  pages: number;
}

export interface TournamentDetailsResponse {
  message: string;
  tournament: Tournament;
}

export interface UpdateTournamentResponse {
  message: string;
  tournament: Tournament;
}

export interface JoinTournamentResponse {
  message: string;
  tournament: Tournament;
}

export interface ShuffleTournamentResponse {
  message: string;
  tournament: Tournament;
}

export type TimeStatus = {
  status: TournamentStatus;
  color: string;
};

export interface TournamentCardProps {
  tournament: Tournament;
  userCountry?: string;
  type?: string;
  onAddToCalendar?: () =>void;
  onShare?: () => void;
}

export type GamesData = {
  id: string;
  name: string;
  image: string;
  url: string;
  color: string;
}[];